/*
 * Package: WebVideo.Config
 * Version: $Id$
 * Copyright (c) 2011-2012 Sergey Leonov
 */

function Config() {}

Config.exec = '/exec';
Config.customer = '/exec/customer';
Config.performer = '/exec/performer';
Config.webmaster = '/exec/webmaster';
Config.manager = '/exec/manager';
Config.serverURL = '/';
Config.dateFormat = 'MM/dd/yyyy';
Config.dateTimeFormat = 'MM/dd/yyyy HH:mm:ss';
Config.defaultTimezone = 'America/Los_Angeles';
Config.location = {
  'countryCode': 'US',
  'city': 'Los Angeles',
  'region': 'CA'  
};
Config.language = 'english';
Config.languageISOCode = 'en';
Config.clientBrowserName = 'Chrome';
Config.clientOSName = 'Windows';
Config.clientDeviceName = 'Computer';
Config.mobile = false;
Config.humanVerificationInstallationState = 'foundation';
Config.humanVerificationProvider = '';
Config.humanVerificationConfiguredProvider = '';
Config.humanVerificationPublicSiteKey = '';
Config.humanVerificationTurnstileSiteKey = '';
Config.humanVerificationRecaptchaSiteKey = '';
Config.checkRecaptchaKey = '';
Config.itemsOnPage = 20;
